RivalIQ.apps.Dashboard.module('legacyRouteHandler', function (legacyRouteHandler, App, Backbone, Marionette, $, _) {

    'use strict';

    legacyRouteHandler.checkForLegacyRoutes = function (location) {

        function legacyRoute(pathRegex, handler) {
            const matches = location.match(pathRegex);
            if (matches) {
                handler(matches);
            }
        }

        legacyRoute(/\/dashboard([^s]|$)/, function () {
            const href = 'overview';
            RivalIQ.execute('history:navigate', href, {
                trigger: true
            });
        });

        legacyRoute(/\/overview#\S+$/, function () {
            const hash = window.location.hash;
            let channel = hash.slice(1);

            if (_.isEmpty(channel)) {
                channel = 'cross_channel';
            }

            const href = `overview/${channel}`;
            RivalIQ.execute('history:navigate', href, {
                trigger: true
            });
        });

        legacyRoute(/\/analyze#\S+/, function () {
            const hash = window.location.hash;
            let channel = hash.slice(1);
            let href = 'analyze';

            switch (channel) {

                case 'create': // not supported anymore, fall through to favorites for a reasonable default.
                case 'favorites':
                    href = '/favorites';
                    break;

                default:
                    if (_.isEmpty(channel) || channel === 'cross_channel_social') {
                        channel = 'cross_channel';
                    }

                    href = `analyze/${channel}`;
            }

            RivalIQ.execute('history:navigate', href, {
                trigger: true
            });
        });

        legacyRoute(/\/company\/(\d+)\/posts\/details\/social-posts.*/, function (matches) {
            const href = ['company', matches[1], 'posts'].join('/');
            RivalIQ.execute('history:navigate', href, {
                trigger: true
            });
        });

        legacyRoute(/\/company\/(\d+)#\S+/, function (matches) {
            const hash = window.location.hash;
            let href = `company/${matches[1]}`;

            switch (hash.slice(2)) {
                case 'site':
                    href += '/pages';
                    break;

                case 'feed':
                    href += '/feed';
                    break;

                default:
                   // just go to the root of the company curation
            }

            RivalIQ.execute('history:navigate', href, {
                trigger: true
            });
        });
    };

});
